export default __webpack_public_path__ + "static/media/logo_white.5382ed36.svg";